import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'

export const SpinnerSC = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid var(${COLOR.SURFACE_OPACITY_LIGHT_10});
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 4px solid transparent;
    border-top-color: var(${COLOR.ACCENT_TERTIARY});
    border-radius: 50%;
    animation: spinner-spin 1.1s infinite ease-in-out;
  }

  @keyframes spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }
`
